import React, { useEffect } from 'react'
import styled from 'styled-components'
import CompFlatFields from '../../comps/FlatFields'
import { MaterialAsphaltProductFields } from '@src/modules/SiteResoureRequirements/parts/4-Material/parts/AsProduct/fields'
import { useSRRInDRS } from '../../useSRRInDRS'
import CompPreviewSection from '../../comps/Section'

interface Props {

}

const CompPreviewMaterialAsphalt = (props: Props) => {
  const {

  } = props
  const [ srr ] = useSRRInDRS()
  console.log(srr)
  if (srr === null) {
    return null
  }
  return <Wrapper>
    { srr.material.asphalt.products
        .map((product, index) => {
          return <CompPreviewSection 
            key={product.id}
            name={`Asphalt Material ${index + 1}`}
          >
            <CompFlatFields
              value={product}
              fields={MaterialAsphaltProductFields}
            />
          </CompPreviewSection>
        })
    }
  </Wrapper>
}

const Wrapper = styled.div`

`

export default CompPreviewMaterialAsphalt